import { inject, Injectable } from '@angular/core';
import { FoerchNormalizeUrlPipe } from '@common/pipes/foerch-normalize-url.pipe';

@Injectable()
export class FoerchDownloadService {
  protected readonly normalizer = inject(FoerchNormalizeUrlPipe);

  private _userAgent = window.navigator.userAgent;

  download(downloadUrl: string): void {
    const a: HTMLAnchorElement = window.document.createElement('a');
    a.href = this.normalizer.transform(downloadUrl);
    if (this.isMobile()) {
      a.download = 'download';
    } else {
      a.target = '_blank';
      a.rel = 'noopener';
      a.setAttribute('role', 'link');
    }
    a.click();
    setTimeout(() => {
      a.remove();
    }, 1000);
  }

  private isMobile(): boolean {
    return (
      /(?:(iPhone|iPod|iPad|Android))/.test(this._userAgent) ||
      (/Macintosh/.test(this._userAgent) && 'ontouchend' in window.document)
    );
  }
}
